<template>
    <v-dialog v-model="show" max-width="600" persistent>
        <v-card class="border-0">
            <v-card-title class="headline primary white--text">
                <v-icon left color="white">mdi-star</v-icon>
                Recurso Premium
            </v-card-title>
            
            <v-card-text class="pt-4">
                <v-alert type="info" outlined>
                    {{ message || 'Este recurso está disponível apenas no plano Premium' }}
                </v-alert>
                
                <div v-if="feature" class="mt-3">
                    <h3>Recurso: {{ feature }}</h3>
                </div>
                
                <div v-if="current !== undefined && limit !== undefined" class="mt-3">
                    <p><strong>Uso atual:</strong> {{ current }} / {{ limit }}</p>
                </div>
                
                <v-divider class="my-4"></v-divider>
                
                <h3 class="mb-3">Benefícios do Plano Premium:</h3>
                <v-list dense>
                    <v-list-item v-for="benefit in benefits" :key="benefit">
                        <v-list-item-icon>
                            <v-icon color="success">mdi-check-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ benefit }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close">Fechar</v-btn>
                <v-btn color="primary" @click="contactUpgrade">
                    <v-icon left>mdi-rocket</v-icon>
                    Fazer Upgrade
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'UpgradeModal',
    
    data() {
        return {
            show: false,
            message: '',
            feature: '',
            current: undefined,
            limit: undefined,
            benefits: [
                'Clientes ilimitados',
                'Sessões ilimitadas',
                'Contratos ilimitados por cliente',
                'Upload de imagens',
                'Integração com Google Calendar',
                'Integração com WhatsApp',
                'Gestão completa de despesas',
                'Comprovantes digitais',
                'Central de notificações',
                'Histórico completo sem limites'
            ]
        };
    },
    
    mounted() {
        // Escutar evento global
        if (window.EventBus) {
            window.EventBus.$on('show-upgrade-modal', this.showModal);
        }
    },
    
    beforeDestroy() {
        if (window.EventBus) {
            window.EventBus.$off('show-upgrade-modal', this.showModal);
        }
    },
    
    methods: {
        showModal(data) {
            this.message = data.message || '';
            this.feature = data.feature || '';
            this.current = data.current;
            this.limit = data.limit;
            this.show = true;
        },
        
        close() {
            this.show = false;
        },
        
        contactUpgrade() {
            // Aqui você pode adicionar lógica para redirecionar para página de upgrade
            // ou abrir WhatsApp/Email para contato
            this.$swal({
                icon: 'info',
                title: 'Entre em Contato',
                text: 'Entre em contato conosco para fazer upgrade para o plano Premium!',
                confirmButtonText: 'OK'
            });
            this.close();
        }
    }
};
</script>
